import React from 'react';
import Navbar from '../components/Navbar';
import Pricing from '../components/Pricing';
import FAQ from '../components/FAQ';
import Footer from '../components/Footer';

export default function PricingPage() {
  return (
    <div>
      <Navbar />
      <div className="pt-20">
        <div className="text-center pt-12 pb-2">
          <span className="inline-flex px-3 py-1 rounded-full bg-neutral-100 text-xs font-medium text-neutral-700">
            Pricing
          </span>
        </div>
        <Pricing />
        <FAQ />
      </div>
      <Footer />
    </div>
  );
}
